import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ALLOWED_CLOUD_CONFIG } from "../internal/internalConstants.js";
import Config from "./BaseConfig.js";

var CloudConfig = /*#__PURE__*/function (_Config) {
  _inherits(CloudConfig, _Config);

  var _super = _createSuper(CloudConfig);

  /**
   * @param {ICloudConfig} userCloudConfig {@link ICloudConfig}
   *
   */
  function CloudConfig(userCloudConfig) {
    var _this;

    _classCallCheck(this, CloudConfig);

    _this = _super.call(this);

    var cloudConfig = _this.filterOutNonSupportedKeys(userCloudConfig, ALLOWED_CLOUD_CONFIG);

    Object.assign(_assertThisInitialized(_this), cloudConfig);

    if (!_this.cloudName) {
      throw 'Missing mandatory field cloudName';
    }

    return _this;
  }

  _createClass(CloudConfig, [{
    key: "extend",
    value: function extend(userCloudConfig) {
      var cloudConfig = this.filterOutNonSupportedKeys(userCloudConfig, ALLOWED_CLOUD_CONFIG);
      return new CloudConfig(Object.assign({}, this, cloudConfig));
    }
    /**
     * @param {string} value Sets the CloudName
     */

  }, {
    key: "setCloudName",
    value: function setCloudName(value) {
      this.cloudName = value;
      return this;
    }
    /**
     * @param {string} value Sets the API Key
     */

  }, {
    key: "setApiKey",
    value: function setApiKey(value) {
      this.apiKey = value;
      return this;
    }
    /**
     * @param {string} value Sets the API Secret
     */

  }, {
    key: "setApiSecret",
    value: function setApiSecret(value) {
      this.apiSecret = value;
      return this;
    }
  }]);

  return CloudConfig;
}(Config);

export default CloudConfig;